import { Box } from "@mui/material";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import MDBox from "components/MDBox";
import "./footer.css";
import PropTypes from "prop-types";
// import ScrollToTopButton from "components/ScrollToTopButton";

function Footer({ isNotAbsolute = true }) {
  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "row", lg: "row" }}
      justifyContent="center"
      alignItems="center"
      className="footer"
      sx={
        isNotAbsolute && {
          position: "absolute",
          bottom: 0,
          left: 0,
          borderRadius: 0,
        }
      }
    >
      <Box component="footer">
        <Box>
          <Typography variant="body2" align="center">
            {"Bản quyền thuộc về © OCOP "}
            {new Date().getFullYear()}
            {"."}
          </Typography>
        </Box>
      </Box>
      {/* {!isNotAbsolute && <ScrollToTopButton sxCustom={{ position: "static" }} />} */}
    </MDBox>
  );
}

Footer.propTypes = {
  isNotAbsolute: PropTypes.bool,
};

export default Footer;
